import React from "react";
import QuoteMark from "./QuoteMark";

const QuoteSection = ({ text, author, variant = "red", background = "beige", ideogram = null }) => {
  const color = variant === "red" ? "#A33B35" : "#5B6D7C";
  return (
    <section className={`quote-section bg-${background}`}>
      {ideogram && (
        <div className="ideogram">
          <img src={ideogram.src} alt={ideogram.alt || ""} />
          {ideogram.caption && (
            <div className="ideogram-caption">
              {ideogram.caption.split("\n").map((l, i) => (
                <div key={i}>{l}</div>
              ))}
            </div>
          )}
        </div>
      )}
      <div className="quote-content">
        <QuoteMark color={color} size={56} />
        <blockquote
          className="quote-text"
          style={{ color: variant === "red" ? "#2D3847" : "#2D3847" }}
        >
          {text}
        </blockquote>
        <div className="quote-author">— {author}</div>
      </div>
    </section>
  );
};

export default QuoteSection;
